import { format } from 'date-fns';

class GoogleCalendarService {
  private tokenClient: any;
  private gapiInited = false;
  private gisInited = false;

  constructor() {
    // Initialize when scripts are loaded
    if (typeof window !== 'undefined') {
      window.addEventListener('load', () => {
        this.initializeGapi();
      });
    }
  }

  private async initializeGapi() {
    // Google Calendar is disabled for now
    console.log('Google Calendar is disabled');
    this.gapiInited = false;
    this.gisInited = false;
    return;
  }

  isAuthorized(): boolean {
    // For development, always return true
    return true;
  }

  async addPomodoroEvent(startTime: Date, duration: number, title: string): Promise<void> {
    // Mock adding event for development
  }

  async getUpcomingEvents(): Promise<any[]> {
    // Return mock events for development
    return [
      {
        id: '1',
        summary: '🍅 Focus Session',
        start: { dateTime: new Date().toISOString() },
        end: { dateTime: new Date(Date.now() + 25 * 60 * 1000).toISOString() },
      },
      {
        id: '2',
        summary: 'Team Meeting',
        start: { dateTime: new Date(Date.now() + 60 * 60 * 1000).toISOString() },
        end: { dateTime: new Date(Date.now() + 120 * 60 * 1000).toISOString() },
      },
    ];
  }
}

export const googleCalendar = new GoogleCalendarService();